import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const  PrivateRoute = ({ allowedRoles, children }) => {
  const { token } = useSelector((state) => state.auth);
  const user = useSelector((state) => state.profile.user);
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" />;
  }

  const userRole = user?.roles?.[0]?.name;

  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" />;
  }

  if (location.pathname === "/business-dashboard") {

    //previous code for shoing  menus from backend

    const userPermissions = user.roles[0].permissions;
    const firstAllowed = userPermissions.find(p => p.path.startsWith("/business-dashboard"));
    if (firstAllowed && firstAllowed.path !== "/business-dashboard") {
      return <Navigate to={firstAllowed.path} />;
    }

    //current code for hiding specific menus
  //    if (location.pathname === "/business-dashboard") {
  //   return <Navigate to="/business-dashboard/my-teams" replace />;
  // }
  }
  return children || <Outlet />;
};

export default PrivateRoute;
